export default __webpack_public_path__ + "static/media/Logo_LFX.897c50f3.png";